module.exports = __webpack_public_path__ + "static/media/play_black.55bc9c54.svg";